// ── English translations for the parent Mini App (Persian-as-key) ────────────
// The KEY is the exact Persian source string; the value is its English rendering.
// `t("…persian…")` returns the Persian key unchanged when lang==fa, and this map's
// value when lang==en (falling back to the Persian key if a translation is
// missing). Interpolation uses {name} placeholders in both key and value.
// Add an entry here whenever you wrap a new Persian string in t().
import { Q_EN } from "./miniapp/questionnaire/questions-en.js";

export const APP_EN = {
  "ضحا قصه": "Zoha Ghese",
  // ── Sample story / channel join / entry (exact source strings) ──
  "یک قصهٔ نمونه را بشنوید": "Listen to a sample story",
  "توقف": "Pause",
  "پخش": "Play",
  "«ضحا» یعنی روشناییِ گرمِ صبحگاه؛ نورِ آفتاب که تاریکی را می‌زداید و امید می‌آورد.":
    "“Zoha” means the warm light of early morning — sunlight that clears away the dark and brings hope.",
  "داستان‌های شخصی‌سازی‌شده برای کودک شما": "Personalized stories for your child",
  "بر اساس روان‌شناسی کودک": "Grounded in child psychology",
  "برای استفاده از ضحا قصه، ابتدا در کانال ما عضو شوید": "To use Zoha Ghese, first join our channel",
  "عضویت در @zoha_ghese": "Join @zoha_ghese",
  "عضویت در {channel}": "Join {channel}",
  "عضویت در کانال ضحا قصه 🌙": "Join the Zoha Ghese channel 🌙",
  "پرداخت در {app} هنوز فعال نیست. به‌زودی اضافه می‌شود.":
    "Payment isn't available in {app} yet. It's coming soon.",
  "عضو شدم ✓": "I've joined ✓",
  "ورود شما از طریق حساب {app} انجام می‌شود. نیازی به ثبت‌نام جداگانه نیست.":
    "You sign in through your {app} account. No separate registration is needed.",
  "به خانوادهٔ ضحا قصه خوش آمدید!": "Welcome to the Zoha Ghese family!",
  "ورود به ضحا قصه": "Enter Zoha Ghese",
  "در حال بررسی عضویت…": "Checking your membership…",
  "هنوز عضویت شما را پیدا نکردیم. ابتدا در کانال عضو شوید، سپس دوباره همین دکمه را بزنید.":
    "We couldn't find you in the channel yet. Join it first, then tap this button again.",
  "قوانین و مقررات": "Terms & Conditions",
  "قوانین استفاده از ضحا قصه": "Terms of use for Zoha Ghese",

  // ── Settings sheet (opened by the host's ⋮ «تنظیمات» item) ──
  "تنظیمات": "Settings",
  "زبان": "Language",
  "درباره": "About",

  // ── Countdown / schedule ──
  "قصه آماده است! 🎉": "The story is ready! 🎉",
  "کمتر از ۱۰ دقیقه": "Less than 10 minutes",
  "کمتر از یک ساعت": "Less than an hour",
  "زمان‌بندی قصه‌های {name}": "{name}'s story schedule",
  "قصه جدید": "New story",
  "قصه بعدی": "Next story",

  // ── Home ──
  "هنوز فرزندی اضافه نشده": "No child added yet",
  "اولین فرزندتان را اضافه کنید": "Add your first child",
  "افزودن فرزند": "Add child",
  "سلام {name} جانِ مهربان": "Hi, dear {name}",
  "سلام مهربان‌جان": "Hello, dear",
  "فرزند جدید": "New child",
  "مشترک": "Subscribed",
  "بدون اشتراک": "No subscription",
  "نوع اشتراک": "Plan",
  "پایان برنامه": "Program ends",
  "شروع برنامه": "Program starts",
  "با تکمیل پرسشنامه": "When the questionnaire is done",
  "سفر رشد {name}": "{name}'s growth journey",
  "{a} از {b}": "{a} of {b}",
  "خرید اشتراک برای {name}": "Subscribe for {name}",
  "تکمیل پرسشنامه برای {name}": "Complete the questionnaire for {name}",
  "⏱ حدود ۱۰ تا ۱۵ دقیقه وقت می‌برد": "⏱ Takes about 10–15 minutes",
  "تمدید اشتراک {name}": "Renew {name}'s subscription",
  "اشتراک امروز به پایان می‌رسد": "Subscription ends today",
  "{n} روز تا پایان اشتراک": "{n} days until the subscription ends",
  "با تمدید، قصه‌ها بدون وقفه ادامه می‌یابند": "Renew and the stories continue without a gap",
  "دعوت دوستان و تخفیف رایگان": "Invite friends & earn a free plan",
  "داستان‌های {name}": "{name}'s stories",
  "برای دریافت داستان‌های مخصوص {name}، ابتدا اشتراک تهیه کنید": "To receive {name}'s special stories, subscribe first",
  "برای شنیدن اولین داستان، لطفاً پرسشنامه را تکمیل کنید": "To hear the first story, please complete the questionnaire",
  "اولین داستان به‌زودی آماده می‌شود": "The first story will be ready soon",
  "داستان‌ها دو بار در هفته ارسال می‌شوند": "Stories are delivered twice a week",
  "جدید": "New",

  // ── Referral ──
  "در حال بارگذاری...": "Loading…",
  "خطا در بارگذاری اطلاعات": "Couldn't load information",
  "دعوت دوستان": "Invite friends",
  "تخفیف برای شما و دوستانتان": "A discount for you and your friends",
  "دعوت‌های موفق شما": "Your successful invites",
  "{n} نفر": "{n} people",
  "{m} اشتراک رایگان": "{m} free plan",
  "{x} از {n} دعوت": "{x} of {n} invites",
  "۱ ماه": "1 month",
  "۲ ماه": "2 months",
  "۳ ماه": "3 months",
  "🎁 دوستتان": "🎁 Your friend",
  "۲۰٪ تخفیف روی اولین اشتراک": "20% off the first subscription",
  "✨ شما": "✨ You",
  "با {n} دعوت، یک ماه اشتراک رایگان": "{n} invites = one free month",
  "کد دعوت شما": "Your invite code",
  "کپی کد": "Copy code",
  "لینک کپی شد!": "Link copied!",
  "کپی لینک دعوت": "Copy invite link",
  "دعوت‌نامه را برایم بفرست": "Send the invite to me",
  "دعوت‌نامه فرستاده شد": "Invite sent",
  "یک پیام آماده در {app} برایتان می‌فرستیم که فقط فورواردش کنید.": "We'll send you a ready-made message on {app} — just forward it.",
  "در گفتگویتان با ربات است — آن را برای دوستانتان فوروارد کنید.": "It's in your chat with the bot — forward it to your friends.",
  "ارسال ناموفق بود. دوباره تلاش کنید.": "Sending failed. Please try again.",

  // ── Add / Edit child ──
  "افزودن فرزند جدید": "Add a new child",
  "اطلاعات کودک شما": "Your child's details",
  "آواتار کودک": "Child's avatar",
  "نمایش کمتر": "Show less",
  "همه ایموجی‌ها": "All emojis",
  "نام کودک": "Child's name",
  "مثلاً آرین، نیلا، رادین...": "e.g. Aryan, Nila, Radin…",
  "تلفظ نام (اختیاری)": "Name pronunciation (optional)",
  "اگر نام طور دیگری خوانده می‌شود، مثلاً «هُدا»": "If the name is read differently, e.g. “Hodā”",
  "فقط برای تلفظ درست نام در صدای داستان استفاده می‌شود.": "Used only to pronounce the name correctly in the story narration.",
  "سن کودک": "Child's age",
  "در حال ذخیره...": "Saving…",
  "افزودن {name} ✓": "Add {name} ✓",
  "خطا در افزودن فرزند": "Couldn't add the child",
  "ویرایش پروفایل {name}": "Edit {name}'s profile",
  "نام و آواتار قابل تغییر است · سن تا پایان اشتراک قفل است": "Name and avatar can change · age is locked until the subscription ends",
  "نام، سن و آواتار قابل تغییر است": "Name, age and avatar can change",
  "مثلاً «هُدا» — فقط برای صدای داستان": "e.g. “Hodā” — only for the story voice",
  "اگر نام فرزندتان طور دیگری خوانده می‌شود، اینجا بنویسید تا راوی درست تلفظ کند.": "If your child's name is read differently, write it here so the narrator says it correctly.",
  "قفل شده": "Locked",
  "سن کودک، داستان‌هایی که برایش نوشته می‌شود را تعیین می‌کند. تا پایان اشتراک فعلی قابل تغییر نیست.": "Your child's age shapes the stories written for them. It can't be changed until the current subscription ends.",
  "ذخیره تغییرات ✓": "Save changes ✓",
  "تغییری ایجاد نشده": "No changes made",
  "خطا در ذخیره تغییرات": "Couldn't save the changes",

  // ── Payment success / questionnaire done ──
  "پرداخت موفق!": "Payment successful!",
  "اشتراک {plan} برای {name} فعال شد.": "The {plan} subscription for {name} is active.",
  "حالا پرسشنامه را تکمیل کنید تا ساخت اولین داستان آغاز شود 📋": "Now complete the questionnaire so the first story can start 📋",
  "مبلغ پرداختی": "Amount paid",
  "داستان‌های دریافتی": "Stories included",
  "{n} تومان": "{n} Toman",
  "{n} داستان صوتی": "{n} audio stories",
  "+ {n} قصهٔ هدیه": "+ {n} bonus stories, free",
  "بازگشت به خانه 🌙": "Back to home 🌙",
  "بازگشت به خانه": "Back to home",
  "پرسشنامه تکمیل شد!": "Questionnaire complete!",
  "پاسخ‌های شما با دقت بررسی می‌شوند تا داستان‌هایی متناسب با روحیه فرزندتان طراحی شود. 🌙": "Your answers are reviewed carefully to craft stories suited to your child's spirit. 🌙",

  // ── Story player ──
  "خطا در بارگذاری صدا": "Couldn't load the audio",
  "{name} عزیز 🌙": "Dear {name} 🌙",
  "در حال بارگذاری صدا...": "Loading audio…",
  "دانلود": "Download",

  // ── Growth journey ──
  "هر داستان، یک قدم به سوی شجاعت بیشتر 🌙": "Every story, a step toward greater courage 🌙",
  "داستان این ماه شنیده شده": "stories heard this month",
  "اکنون": "Now",
  "اولین داستان": "First story",
  "{name} اولین قصه را شنید": "{name} heard their first story",
  "۳ قصه شنیده": "3 stories heard",
  "سه قصه با موفقیت شنیده شد": "Three stories heard successfully",
  "نیمه‌راه ماه": "Halfway this month",
  "{a} از {b} داستان": "{a} of {b} stories",
  "قهرمان ماه": "Hero of the month",
  "تمام {n} داستان کامل شود": "Complete all {n} stories",
  "شنیدن داستان‌ها «در کنار هم»، لحظه‌های گرمی می‌سازد که {name} هرگز فراموش نمی‌کند.": "Listening to stories “together” creates warm moments {name} will never forget.",

  // ── Subscription ──
  "اشتراک داستان": "Story subscription",
  "برای {name} — ۲ داستان صوتی در هفته": "For {name} — 2 audio stories a week",
  "داستان شخصی‌سازی‌شده با نام کودک شما": "A personalized story with your child's name",
  "بر اساس روان‌شناسی و نیاز کودک": "Based on child psychology and needs",
  "۲ داستان صوتی در هفته": "2 audio stories a week",
  "ارسال مستقیم در ضحا قصه": "Delivered right inside Zoha Ghese",
  "{n}٪ تخفیف": "{n}% off",
  "ستاره": "Stars",
  "تومان": "Toman",
  "بسته پیشنهادی": "Recommended",
  "کد دعوت دارید؟ (اختیاری — فقط برای اولین خرید)": "Have an invite code? (optional — first purchase only)",
  "کد معتبر — ۲۰٪ تخفیف اعمال شد": "Valid code — 20% off applied",
  "کد: {code}": "Code: {code}",
  "مثلاً ZH8K3P": "e.g. ZH8K3P",
  "اعمال": "Apply",
  "❌ کد نامعتبر است یا قبلاً استفاده شده": "❌ The code is invalid or already used",
  "❌ این کد دعوت متعلق به شماست و برای هیچ‌کدام از فرزندانتان قابل استفاده نیست": "❌ This invite code is yours and can't be used for any of your children",
  "اشتراک {plan} رایگان شما آماده است!": "Your free {plan} subscription is ready!",
  "استفاده از {n} دعوت موفق": "Use {n} successful invites",
  "برای استفاده ضربه بزنید": "Tap to use",
  "{n}٪ تخفیف روی این پلن — برای استفاده ضربه بزنید": "{n}% off this plan — tap to use",
  "قیمت پلن": "Plan price",
  "🎁 اشتراک رایگان (دعوت دوستان)": "🎁 Free subscription (referrals)",
  "🎁 تخفیف دعوت دوستان ({n}٪)": "🎁 Referral discount ({n}%)",
  "تخفیف کد دعوت ({n}٪)": "Invite-code discount ({n}%)",
  "مبلغ نهایی": "Final amount",
  "تخفیف‌های شما (فقط یکی قابل انتخاب است)": "Your discounts (choose one)",
  "قیمت با این تخفیف: {n}": "Price with this discount: {n}",
  "فقط تا {date}": "Until {date} only",
  "رایگان می‌شود": "Becomes free",
  "کد تخفیف دارید؟": "Have a discount code?",
  "مثلاً SARA20": "e.g. SARA20",
  "اعمال": "Apply",
  "این کد معتبر نیست": "This code isn't valid",
  "در حال پردازش...": "Processing…",
  "یک طرح را انتخاب کنید": "Choose a plan",
  "🎁 دریافت اشتراک رایگان": "🎁 Get the free subscription",
  "پرداخت {n} ⭐ با استارز تلگرام": "Pay {n} ⭐ with Telegram Stars",
  "پرداخت {n} تومان از کیف پول {app}": "Pay {n} Toman from your {app} wallet",
  "پرداخت از طریق کیف پول {app}": "Pay from your {app} wallet",
  "برای پشتیبانی، از بخش تنظیمات پیام بفرستید.": "For support, send us a message from Settings.",
  "پشتیبانی": "Support",
  "پشتیبانی ویژه": "Priority support",
  "سؤالی دارید؟ همین‌جا برای ما پیام بفرستید.": "Have a question? Send us a message here.",
  "ارتباط با ما": "Contact us",
  "پیامتان را بنویسید؛ پاسخ پشتیبانی همین‌جا نمایش داده می‌شود.": "Write your message; the support reply will appear here.",
  "هنوز پیامی ارسال نشده است": "No messages yet.",
  "ارسال پاسخ ناموفق بود": "The reply could not be delivered.",
  "پیام شما...": "Your message...",
  "ارسال پیام": "Send message",
  "پرداخت امن از طریق کیف پول {app} · بدون کارمزد اضافه": "Secure payment via {app} wallet · no extra fees",
  "پرداخت {n} تومان با زرین‌پال": "Pay {n} Toman with ZarinPal",
  "پرداخت امن از طریق درگاه زرین‌پال · با تمام کارت‌های بانکی": "Secure payment via the ZarinPal gateway · any Iranian bank card",
  "درگاه پرداخت زرین‌پال در مرورگر باز شد. پس از پرداخت، به همین‌جا بازگردید؛ اشتراک به‌صورت خودکار فعال می‌شود.": "The ZarinPal payment page opened in your browser. After paying, come back here — your subscription activates automatically.",
  "پرداخت اقساطی با": "Pay in installments with",
  "صفحهٔ پرداخت اسنپ‌پی در مرورگر باز شد. پس از پرداخت، به همین‌جا بازگردید؛ اشتراک به‌صورت خودکار فعال می‌شود.": "The SnappPay payment page opened in your browser. After paying, come back here — your subscription activates automatically.",
  "در انتظار پرداخت": "Awaiting payment",
  "صورت‌حساب پرداخت به گفتگوی شما با ربات ضحا قصه ارسال شد. لطفاً به ربات بازگردید و پرداخت را کامل کنید.": "A payment invoice was sent to your chat with the Zoha Ghese bot. Please return to the bot and complete the payment.",
  "رفتن به ربات برای پرداخت": "Go to the bot to pay",
  "انصراف": "Cancel",
  "پرداخت ناموفق بود. دوباره تلاش کنید.": "Payment failed. Please try again.",
  "پرداخت تلگرام در دسترس نیست": "Telegram payment isn't available",
  "پرداخت تکمیل نشد. اگر مبلغ کسر شده با پشتیبانی تماس بگیرید.": "Payment wasn't completed. If you were charged, contact support.",
  "خطا در پرداخت": "Payment error",

  // ── App shell / auth ──
  "داده‌های ورود یافت نشد. لطفاً برنامه را از داخل ربات باز کنید.": "Sign-in data not found. Please open the app from inside the bot.",
  "خطا در احراز هویت": "Authentication error",

  // ── Questionnaire chrome ──
  "لطفاً این سوال را پاسخ دهید": "Please answer this question",
  "لطفاً یک مورد را انتخاب کنید": "Please choose one",
  "بله": "Yes",
  "خیر": "No",
  "شدت ترس:": "Fear intensity:",
  "شدت {n}": "Severity {n}",
  "هرگز / به ندرت": "Never / rarely",
  "کمتر از نیمی از زمان": "Less than half the time",
  "حدود نیمی از زمان": "About half the time",
  "بیش از نیمی از زمان": "More than half the time",
  "بخش {a} از {b}": "Section {a} of {b}",
  "بخش قبلی": "Previous section",
  "قبلی": "Previous",
  "بعدی": "Next",
  "ارسال پرسشنامه": "Submit questionnaire",
  "در حال ارسال...": "Submitting…",
  "پرسشنامهٔ این کودک از قبل تکمیل شده": "This child's questionnaire is already complete",
  "می‌توانید از همان پاسخ‌های قبلی استفاده کنید یا پرسشنامهٔ تازه‌ای پر کنید.": "You can reuse the previous answers or fill out a new questionnaire.",
  "در حال آماده‌سازی...": "Preparing…",
  "✓ استفاده از پرسشنامهٔ قبلی": "✓ Use the previous questionnaire",
  "تکمیل پرسشنامهٔ جدید": "Fill a new questionnaire",
  "چالش پررنگی ثبت نشد ✨": "No major challenge flagged ✨",
  "بر اساس پاسخ‌های شما، کودک در حال حاضر چالشِ برجسته‌ای ندارد. داستان‌ها بر پرورشِ توانمندی‌ها و ارزش‌های مورد نظرِ شما تمرکز می‌کنند.": "Based on your answers, your child currently has no standout challenge. The stories will focus on nurturing strengths and the values you care about.",
  "موارد زیر از پاسخ‌های شما استخراج شده‌اند.": "The items below are drawn from your answers.",
  "یک یادداشت دوستانه": "A friendly note",
  "چند مورد از این نشانه‌ها را هم‌زمان علامت زده‌اید. این پرسشنامه تشخیصی نیست، اما در این حوزه، مشورتِ زودهنگام با پزشک کودک یا متخصص رشد بسیار ارزشمند است. پیشنهاد می‌کنیم مستقل از داستان‌ها، این موضوع را با یک متخصص در میان بگذارید. 🌱": "You've marked several of these signs together. This questionnaire isn't diagnostic, but in this area early consultation with a pediatrician or developmental specialist is very valuable. We suggest discussing it with a specialist, independently of the stories. 🌱",
  "خطا در استفاده از پرسشنامهٔ قبلی": "Couldn't reuse the previous questionnaire",
  "خطا در ارسال پرسشنامه": "Couldn't submit the questionnaire",

  // ── (legacy guesses kept harmless) Channel join / entry ──
  "به کانال ما بپیوندید": "Join our channel",
  "برای استفاده از ضحا قصه، لطفاً ابتدا در کانال ما عضو شوید": "To use Zoha Ghese, please join our channel first",
  "عضویت در کانال": "Join the channel",
  "عضو شدم، ادامه": "I've joined, continue",
  "در حال بررسی...": "Checking…",
  "هنوز عضو نشده‌اید. لطفاً ابتدا در کانال عضو شوید.": "You haven't joined yet. Please join the channel first.",
  "خطا در بررسی عضویت": "Couldn't verify membership",
  "یک قصهٔ نمونه بشنوید": "Listen to a sample story",
  "رقصِ نورهایِ نقره‌ای بر رودِ مهتاب": "The Dance of Silver Lights on the Moonlit River",

  // ── Enter / welcome ──
  "به ضحا قصه خوش آمدید": "Welcome to Zoha Ghese",
  "قصه‌های شخصی‌سازی‌شده برای فرزند دلبند شما": "Personalized stories for your beloved child",
  "ورود به ضحا قصه": "Enter Zoha Ghese",
  "ضحا": "Zoha",
  "«ضحا» یعنی روشناییِ آغازِ روز؛ نامی از قرآن، نمادِ امید و آغازی تازه.":
    "“Zoha” means the bright light of early morning — a Quranic name, a symbol of hope and a fresh beginning.",
  "با ورود، قوانین و مقررات را می‌پذیرید": "By entering, you accept the terms and conditions",
  "قوانین و مقررات": "Terms & conditions",

  // ── Common actions ──
  "بازگشت": "Back",
  "بستن": "Close",
  "ذخیره": "Save",
  "انصراف": "Cancel",
  "ادامه": "Continue",
  "تأیید": "Confirm",
  "بعدی": "Next",
  "قبلی": "Previous",
  "در حال ارسال...": "Sending…",
  "در حال ذخیره...": "Saving…",
  "تلاش دوباره": "Try again",

  // ── Questionnaire content (sections, questions, options, concern labels) ──
  "اطلاعات پایه": "Basic information",
  "برای هماهنگ‌کردن فضای داستان با زندگی واقعی کودک.": "To align the story's world with your child's real life.",
  "جایگاه کودک در خانواده": "The child's place in the family",
  "کودک چندمین فرزند خانواده است؟ آیا خواهر یا برادر دارد؟": "Which child is this in the family? Do they have siblings?",
  "تغییرات مهم زندگی": "Major life changes",
  "آیا در یک تا دو سال گذشته یکی از این تغییرات در زندگی کودک رخ داده است؟ (می‌توانید چند مورد را انتخاب کنید)": "In the past year or two, has one of these changes happened in your child's life? (you can pick several)",
  "هیچ‌کدام / تغییر خاصی رخ نداده است": "None / no particular change",
  "تولد خواهر یا برادر جدید": "Birth of a new sibling",
  "تغییر منزل یا شهر محل زندگی": "Moving home or city",
  "شروع یا تغییر مدرسه/مهدکودک": "Starting or changing school/kindergarten",
  "جدایی، طلاق یا اختلاف شدید و مداوم والدین": "Separation, divorce, or ongoing intense conflict between the parents",
  "از دست دادن یکی از عزیزان، آشنایان یا حیوان خانگی": "Loss of a loved one, acquaintance, or pet",
  "بیماری یا بستری‌شدن (کودک یا یکی از نزدیکان)": "Illness or hospitalization (the child or someone close)",
  "تغییر محسوس شرایط اقتصادی یا شغلی والدین": "A noticeable change in the parents' financial or work situation",
  "سرشت و سبک رفتاری": "Temperament & behavioral style",
  "ثبات رفتاری و تنظیم هیجانی کودک را می‌سنجد.": "Measures the child's behavioral consistency and emotional regulation.",
  "الف) خلق‌وخو و تنظیم هیجانی": "a) Mood & emotional regulation",
  "لطفاً فراوانی بروز رفتارهای زیر را در ماه‌های اخیر مشخص کنید.": "Please rate how often the following behaviors occurred in recent months.",
  "وقتی مجبور است کاری را که دوست ندارد انجام دهد، سریعاً عصبانی یا بدخلق می‌شود.": "When made to do something they dislike, they quickly become angry or moody.",
  "هنگام مواجهه با یک چالش یا شکست کوچک، به‌سرعت ناامید می‌شود و تسلیم می‌شود.": "Faced with a small challenge or setback, they quickly get discouraged and give up.",
  "برای اتمام بازی‌ها یا وظایفی که زمان بیشتری نیاز دارند، به‌سادگی تمرکز خود را از دست می‌دهد.": "For games or tasks that take longer, they easily lose focus.",
  "هنگام تعویق در خواسته‌هایش (مثلاً صبر کردن برای نوبت بازی یا هدیه)، بی‌قراری می‌کند و کنترل خود را از دست می‌دهد.": "When their wishes are delayed (e.g. waiting for a turn or a gift), they become restless and lose control.",
  "وقتی به محیط‌ها یا افراد جدید وارد می‌شود، واکنش‌های شدیداً منفی (مانند گریه یا چسبندگی) نشان می‌دهد.": "In new places or with new people, they react very negatively (e.g. crying or clinging).",
  "توانایی مدیریت و آرام‌کردن خود را پس از یک هیجان شدید (مانند خشم یا ترس) دارد.": "They can manage and calm themselves after a strong emotion (such as anger or fear).",
  "ب) سبک پردازش و انگیزه": "b) Processing style & motivation",
  "این پاسخ‌ها فقط برای تنظیم لحن و شیوهٔ روایت استفاده می‌شوند.": "These answers are used only to tune the tone and style of the narration.",
  "کودک شما هنگام مواجهه با مشکلات، معمولاً…": "When facing problems, your child usually…",
  "منطق‌محور": "Logic-driven",
  "به‌دنبال راه‌حل‌های عینی و منطقی می‌گردد": "looks for concrete, logical solutions",
  "روابط‌محور": "Relationship-driven",
  "به‌دنبال کمک‌گرفتن از دیگران و دلجویی است": "seeks help and comfort from others",
  "خلاق و انعطاف‌پذیر": "Creative & flexible",
  "به‌دنبال راه‌های خلاقانه و غیرمنتظره است": "looks for creative, unexpected ways",
  "برنامه‌محور": "Plan-driven",
  "به‌دنبال اتمام وظیفه و داشتن یک برنامهٔ مشخص است": "wants to finish the task and have a clear plan",
  "مهم‌ترین عاملی که انگیزهٔ تلاش و موفقیت را در کودک ایجاد می‌کند چیست؟": "What most motivates your child to try and succeed?",
  "دستیابی به هدف فردی و اثبات توانایی‌هایش": "Reaching a personal goal and proving their abilities",
  "تأیید و ستایش دیگران": "Others' approval and praise",
  "کسب تجربیات جدید و سرگرمی": "Gaining new experiences and fun",
  "احساس مسئولیت‌پذیری در قبال وظیفه‌ای که به‌عهده گرفته است": "A sense of responsibility for a task they've taken on",
  "نشانه‌های هیجانی و رفتاری": "Emotional & behavioral signs",
  "برای هر مورد، فراوانی بروز آن در ۶ ماه گذشته را مشخص کنید.": "For each item, rate how often it occurred in the past 6 months.",
  "الف) نشانه‌های هیجانی": "a) Emotional signs",
  "اضطراب، غم و اعتمادبه‌نفس.": "Anxiety, sadness, and self-confidence.",
  "نگرانی و افکار ناراحت‌کننده": "Worries & distressing thoughts",
  "نگرانی‌ها یا افکار ناراحت‌کننده دارد که به‌آسانی رهایش نمی‌کنند.": "Has worries or distressing thoughts that don't easily let go of them.",
  "غم و دلمردگی": "Sadness & low spirits",
  "بدون دلیل مشخص، غمگین، دلمرده یا گریان به‌نظر می‌رسد.": "For no clear reason, seems sad, dispirited, or tearful.",
  "کم‌آوردن و «نمی‌تونم»": "Giving up & “I can't”",
  "زود از پس کارها برنمی‌آید و جملاتی مانند «نمی‌تونم» یا «بلد نیستم» زیاد می‌گوید.": "Gives up on tasks quickly and often says things like “I can't” or “I don't know how.”",
  "کمرویی و کناره‌گیری": "Shyness & withdrawal",
  "کم‌رو و کناره‌گیر است؛ به‌سختی با آدم‌های تازه یا در جمع باز می‌شود.": "Is shy and withdrawn; hardly opens up to new people or in a group.",
  "نشانه‌های جسمانیِ استرس": "Physical signs of stress",
  "هنگام استرس، بدون علت پزشکیِ مشخص دچار دل‌درد، سردرد یا حالت تهوع می‌شود.": "Under stress, with no clear medical cause, gets stomachaches, headaches, or nausea.",
  "اضطراب کارهای روزمره": "Anxiety about daily activities",
  "برای انجام کارهای روزمره (مانند رفتن به مهدکودک/مدرسه) به‌شدت مضطرب یا بی‌قرار می‌شود.": "Becomes very anxious or restless about daily activities (such as going to kindergarten/school).",
  "ب) لجبازی، نافرمانی و پرخاشگری": "b) Defiance, disobedience & aggression",
  "عصبانیت و ازدست‌دادن کنترل": "Anger & losing control",
  "زود عصبانی می‌شود و کنترل خلق‌وخویش را از دست می‌دهد.": "Gets angry quickly and loses control of their temper.",
  "بحث و مخالفت با قوانین": "Arguing & defying rules",
  "با درخواست‌ها و قانون‌های والدین یا معلم، مکرراً بحث و مخالفت می‌کند.": "Repeatedly argues with and resists the parents' or teacher's requests and rules.",
  "نافرمانی": "Disobedience",
  "حتی با اصرار و یادآوریِ مکرر، از انجام خواستهٔ بزرگ‌ترها سر باز می‌زند.": "Even with repeated insistence and reminders, refuses to do what adults ask.",
  "نپذیرفتن مسئولیت": "Not taking responsibility",
  "تقصیر اشتباهات خودش را به گردن دیگران می‌اندازد و مسئولیت نمی‌پذیرد.": "Blames others for their own mistakes and doesn't take responsibility.",
  "پرخاشگری فیزیکی": "Physical aggression",
  "با کوچک‌ترین ناراحتی، با داد زدن، فحاشی، زدن، گاز گرفتن یا پرت‌کردن وسایل واکنش نشان می‌دهد.": "At the slightest upset, reacts by yelling, swearing, hitting, biting, or throwing things.",
  "کینه و تلافی": "Grudges & payback",
  "کینه به دل می‌گیرد یا به‌دنبال تلافی‌کردن است.": "Holds a grudge or seeks to get even.",
  "زیرپا گذاشتن قوانین": "Breaking rules",
  "قانون‌های خانه یا مدرسه را زیر پا می‌گذارد (دروغ گفتن، برداشتن وسایل بدون اجازه).": "Breaks the rules of home or school (lying, taking things without permission).",
  "توجه، روابط و توانمندی‌ها": "Attention, relationships & strengths",
  "توجه و تمرکز، روابط با هم‌سالان و نقاط قوت کودک.": "Attention and focus, peer relationships, and the child's strengths.",
  "ج) توجه، تمرکز و تکانشگری": "c) Attention, focus & impulsivity",
  "حواس‌پرتی و تمرکز کم": "Distractibility & low focus",
  "حواسش زود پرت می‌شود و تمرکز روی یک فعالیت برایش دشوار است.": "Is easily distracted and finds it hard to focus on one activity.",
  "بی‌قراری و پرتحرکی": "Restlessness & hyperactivity",
  "بی‌قرار است؛ مدام در حال تکان‌خوردن یا دویدن است و آرام نشستن برایش سخت است.": "Is restless; constantly fidgeting or running, and finds sitting still hard.",
  "تکانشگری": "Impulsivity",
  "پیش از فکر کردن، حرف می‌زند یا دست به کاری می‌زند.": "Speaks or acts before thinking.",
  "دشواری صبر کردن": "Difficulty waiting",
  "صبر کردن برای نوبتش، چه در بازی و چه در صف، برایش بسیار دشوار است.": "Waiting for their turn, in play or in line, is very hard for them.",
  "د) روابط با هم‌سالان": "d) Peer relationships",
  "نداشتن دوست صمیمی": "No close friend",
  "دوست صمیمی ندارد یا در دوست‌یابی مشکل دارد.": "Has no close friend or struggles to make friends.",
  "دشواری ورود به بازی گروهی": "Difficulty joining group play",
  "نمی‌داند چطور وارد بازیِ گروهیِ بچه‌های دیگر شود.": "Doesn't know how to join other children's group play.",
  "دشواری رعایت نوبت و سهیم‌شدن": "Difficulty taking turns & sharing",
  "به‌سختی نوبت را رعایت می‌کند یا وسایلش را با دیگران به اشتراک می‌گذارد.": "Struggles to take turns or share their things with others.",
  "مورد اذیت یا طردشدن": "Being teased or excluded",
  "توسط بچه‌های دیگر مسخره، اذیت یا از بازی کنار گذاشته می‌شود.": "Is mocked, teased, or left out of play by other children.",
  "زورگویی به دیگران": "Bullying others",
  "نسبت به بچه‌های دیگر پرخاشگر است یا آن‌ها را به انجام خواسته‌اش مجبور می‌کند (زورگویی).": "Is aggressive toward other children or forces them to do what they want (bullying).",
  "ترجیح بازی انفرادی": "Prefers solitary play",
  "ترجیح می‌دهد بیشتر وقت‌ها تنها بازی کند تا با بچه‌های هم‌سن‌وسال.": "Usually prefers to play alone rather than with peers.",
  "ه) نقاط قوت و رفتار جامعه‌پسند": "e) Strengths & prosocial behavior",
  "در این بخش، فراوانیِ بیشتر نشانهٔ توانمندیِ بیشترِ کودک است.": "In this section, higher frequency means greater strength in your child.",
  "با بچه‌های کوچک‌تر یا ناراحت، مهربان و دلسوز است.": "Is kind and caring toward younger or upset children.",
  "با میل خودش اسباب‌بازی، غذا یا وسایلش را با دیگران قسمت می‌کند.": "Willingly shares toys, food, or belongings with others.",
  "بدون اینکه از او خواسته شود، به دیگران کمک می‌کند.": "Helps others without being asked.",
  "وقتی کسی ناراحت است متوجه می‌شود و سعی می‌کند او را آرام کند.": "Notices when someone is upset and tries to comfort them.",
  "با پشتکار، کارها و بازی‌هایش را تا انتها ادامه می‌دهد.": "With perseverance, sees their tasks and games through to the end.",
  "عادت‌ها و ویژگی‌های دیگر": "Habits & other traits",
  "خواب و تغذیه، برتری‌طلبی و استفاده از صفحه‌نمایش.": "Sleep and eating, entitlement, and screen use.",
  "و) خواب و تغذیه": "f) Sleep & eating",
  "مشکل خواب یا کابوس": "Sleep trouble or nightmares",
  "برای به‌خواب‌رفتن مشکل دارد یا کابوس/بیدارشدن‌های مکررِ شبانه دارد.": "Has trouble falling asleep or has nightmares/frequent night wakings.",
  "سخت‌گیری در غذا": "Fussy eating",
  "در خوردن غذا بسیار سخت‌گیر است یا از خوردن بسیاری از غذاها امتناع می‌کند.": "Is very fussy about food or refuses to eat many foods.",
  "عادت‌های تکراریِ آرامش‌بخش": "Repetitive soothing habits",
  "عادت‌های تکراریِ آرامش‌بخش دارد (جویدن ناخن، مکیدن انگشت، ور رفتن با مو و مانند آن).": "Has repetitive soothing habits (nail-biting, thumb-sucking, hair-twirling, and the like).",
  "ح) تکبر، برتری‌طلبی و احساسِ محق‌بودن": "h) Arrogance, superiority & entitlement",
  "این ویژگی‌ها معمولاً اکتسابی و قابل‌اصلاح‌اند و موضوع خوبی برای یک داستان آموزنده‌اند.": "These traits are usually learned and correctable, and make a good subject for an instructive story.",
  "احساس برتری": "Sense of superiority",
  "فکر می‌کند از بقیهٔ بچه‌ها بهتر یا خاص‌تر است و این را به زبان می‌آورد.": "Thinks they're better or more special than other children and says so.",
  "نپذیرفتن باخت": "Not accepting losing",
  "وقتی برنده نمی‌شود یا بهترین نیست، به‌شدت ناراحت می‌شود یا نتیجه را نمی‌پذیرد.": "When not winning or not the best, gets very upset or won't accept the outcome.",
  "توقع برآورده‌شدن فوری خواسته‌ها": "Expecting instant gratification",
  "انتظار دارد خواسته‌هایش فوراً و بدون چون‌وچرا برآورده شود.": "Expects their wishes to be met immediately and without question.",
  "خودمحوری در گفت‌وگو": "Self-centered in conversation",
  "بیشتر دوست دارد دربارهٔ خودش و توانایی‌هایش صحبت کند تا گوش دادن به دیگران.": "Prefers talking about themselves and their abilities over listening to others.",
  "حسادت به توجه دیگران": "Jealous of others' attention",
  "وقتی دیگران هم توجه یا تحسین می‌گیرند (نه فقط او)، حسادت یا خشم نشان می‌دهد.": "When others also get attention or praise (not just them), shows jealousy or anger.",
  "ک) استفاده از صفحه‌نمایش و فناوری": "k) Screen & technology use",
  "خشم هنگام پایان زمان صفحه‌نمایش": "Anger when screen time ends",
  "وقتِ استفاده از تبلت/موبایل/تلویزیون تمام می‌شود، به‌شدت عصبانی می‌شود یا مقاومت می‌کند.": "When tablet/phone/TV time ends, becomes very angry or resists.",
  "ترجیح صفحه‌نمایش به بازی": "Preferring screens over play",
  "ترجیح می‌دهد به‌جای بازیِ فیزیکی یا با دیگران، وقتش را با صفحه‌نمایش بگذراند.": "Prefers spending time on a screen rather than physical or social play.",
  "نشانه‌های رشدی (غربالگری اولیه)": "Developmental signs (early screening)",
  "این آیتم‌ها صرفاً غربالگریِ اولیه‌اند و جنبهٔ تشخیصی ندارند.": "These items are only an early screen and are not diagnostic.",
  "ط) انعطاف‌پذیری، رفتارهای تکراری و حساسیت‌های حسی": "i) Flexibility, repetitive behaviors & sensory sensitivities",
  "مقاومت در برابر تغییر روال": "Resistance to routine change",
  "تغییر برنامه یا روال روزمره، او را بسیار ناراحت یا مضطرب می‌کند.": "A change in schedule or daily routine upsets or distresses them greatly.",
  "حرکات تکراری": "Repetitive movements",
  "حرکات تکراری دارد (مانند دست‌زدن به هم، تاب‌خوردن، چیدن اشیا به‌ترتیبِ خاص).": "Has repetitive movements (such as hand-flapping, rocking, lining objects up in a certain order).",
  "حساسیت حسی شدید": "Strong sensory sensitivity",
  "نسبت به صدا، نور، لمس یا بافتِ خاصی از پارچه/غذا حساسیتِ شدید دارد.": "Is highly sensitive to sound, light, touch, or a particular texture of fabric/food.",
  "تماس چشمی یا اشارهٔ کمتر": "Less eye contact or pointing",
  "کمتر تماسِ چشمی برقرار می‌کند یا کمتر برای نشان‌دادنِ چیزی به دیگران اشاره می‌کند.": "Makes less eye contact or points less to show others something.",
  "درنیافتن احساسات دیگران": "Not reading others' feelings",
  "متوجهٔ ناراحتی یا احساساتِ دیگران نمی‌شود یا واکنشِ مناسب نشان نمی‌دهد.": "Doesn't notice others' distress or feelings, or doesn't respond appropriately.",
  "ی) گفتار، زبان و بازیِ نمادین": "j) Speech, language & symbolic play",
  "تأخیر در گفتار": "Speech delay",
  "در ساختنِ جمله یا بیانِ منظورش نسبت به هم‌سن‌وسالانش عقب‌تر به‌نظر می‌رسد.": "Seems behind their peers in forming sentences or expressing themselves.",
  "تکرار طوطی‌وار کلمات": "Echoing words",
  "کلمات یا جمله‌های شنیده‌شده را بدونِ تغییر و مکرراً تکرار می‌کند.": "Repeats heard words or sentences unchanged and over and over.",
  "مشارکت کم در بازی وانمودی": "Little pretend play",
  "در بازیِ وانمودی (مثلاً وانمود کردن که عروسک غذا می‌خورد) کمتر شرکت می‌کند.": "Takes part less in pretend play (e.g. pretending a doll is eating).",
  "ترس‌ها و اضطراب": "Fears & anxiety",
  "برای شناسایی محرک‌های دقیق ترس و شدت آن‌ها.": "To identify the exact triggers of fear and their intensity.",
  "ز) ترس‌های اختصاصی": "g) Specific fears",
  "آیا کودک این ترس را دارد؟ در صورت بله، شدت آن را مشخص کنید.": "Does the child have this fear? If yes, indicate its intensity.",
  "ترس از تاریکی یا تنها خوابیدن در اتاقش.": "Fear of the dark or sleeping alone in their room.",
  "ترس از حیوانات خاص (مثلاً سگ، حشرات) یا صداهای بلند و ناگهانی.": "Fear of certain animals (e.g. dogs, insects) or loud, sudden noises.",
  "ترس از غریبه‌ها یا موقعیت‌های جدید (مانند مطب دکتر یا دندان‌پزشکی).": "Fear of strangers or new situations (such as the doctor's or dentist's office).",
  "اضطراب جدایی (ترس از دور شدن از شما یا فرد مراقبت‌کنندهٔ اصلی).": "Separation anxiety (fear of being away from you or the main caregiver).",
  "ترس از آسیب جسمانی (افتادن، بیمار شدن، یا اتفاقات ناگهانی).": "Fear of physical harm (falling, getting sick, or sudden accidents).",
  "توصیف دقیق ترسِ اصلی": "Describe the main fear precisely",
  "اگر ترسی دارد، دقیق‌ترین ترس کودک را که بیشترین اختلال را در زندگی روزانه‌اش ایجاد می‌کند توصیف کنید.": "If they have a fear, describe the child's most specific fear that most disrupts their daily life.",
  "علائم جسمانی هنگام ترس": "Physical symptoms during fear",
  "کودک هنگام ترس شدید چه واکنش‌های جسمانی نشان می‌دهد؟ (لرزیدن، دل‌پیچه، سردرد، مشکلات خواب…)": "What physical reactions does the child show during intense fear? (trembling, stomach cramps, headache, sleep problems…)",
  "خانواده و اولویت داستان": "Family & story priority",
  "جوّ خانه و انتخاب مهم‌ترین موضوع برای اولین داستان.": "The home atmosphere and choosing the most important topic for the first story.",
  "زمینهٔ خانوادگی و روابط": "Family context & relationships",
  "جوّ کلیِ خانه را چطور توصیف می‌کنید؟": "How would you describe the overall atmosphere at home?",
  "آرام و باثبات": "Calm and stable",
  "گاهی پرتنش": "Sometimes tense",
  "اغلب پرتنش یا پرتعارض": "Often tense or full of conflict",
  "آیا کودک شاهد دعوا یا تنش شدید بین بزرگسالان خانه بوده است؟": "Has the child witnessed serious fights or tension between the adults at home?",
  "بله، به‌ندرت": "Yes, rarely",
  "بله، گاهی": "Yes, sometimes",
  "بله، مکرراً": "Yes, frequently",
  "رابطهٔ کودک با خواهر/برادر": "The child's relationship with siblings",
  "رقابت، دلبستگی، دعوای مکرر و مانند آن. (اختیاری)": "Rivalry, attachment, frequent fighting, and the like. (optional)",
  "واکنش به تغییرات زندگی": "Reaction to life changes",
  "اگر یکی از تغییرات «اطلاعات پایه» رخ داده، کودک چه واکنشی نشان داده است؟ (اختیاری)": "If one of the “Basic information” changes happened, how did the child react? (optional)",
  "اولویت داستان اول": "Priority for the first story",
  "مهم‌ترین موضوع را برای اولین داستان انتخاب کنید؛ موضوعات دیگر در داستان‌های بعدی دنبال می‌شوند.": "Choose the most important topic for the first story; other topics follow in later stories.",
  "کدام موضوع بیش از همه برای اولین داستان مهم است؟": "Which topic matters most for the first story?",
  "واکنش والدینی": "Parental response",
  "نقش شما در الگوسازی رفتار و مدیریت هیجانات کودک.": "Your role in modeling behavior and managing your child's emotions.",
  "در مواجهه با رفتار نامناسب کودک، آرامش خود را حفظ می‌کنید و با ثبات برخورد می‌کنید.": "When faced with your child's misbehavior, you stay calm and respond consistently.",
  "قانون‌ها و مرزهای خانه برای کودک روشن، قابل پیش‌بینی و ثابت هستند.": "The home's rules and boundaries are clear, predictable, and consistent for the child.",
  "کودک را تشویق می‌کنید احساسات خود (ترس، خشم، نگرانی) را با کلمات بیان کند.": "You encourage the child to express their feelings (fear, anger, worry) in words.",
  "از رفتارهای جسورانه یا خوبِ کوچکِ کودک، همان لحظه و به‌طور مشخص تعریف می‌کنید.": "You praise the child's brave or good little behaviors right then and specifically.",
  "هنگامی که خودتان تحت فشارید، گفتگوی درونیِ مثبت را برای کودک الگو قرار می‌دهید.": "When you're under pressure, you model positive self-talk for the child.",
  "تمایل دارید کودک را از موقعیت‌های چالش‌برانگیز دور نگه دارید و بیش از حد از او محافظت کنید.": "You tend to keep the child away from challenging situations and overprotect them.",
  "قهرمان و سناریوی داستان": "Hero & story scenario",
  "برای همذات‌پنداری مؤثر و انتقال ارزش‌های مطلوب.": "For effective identification and conveying the desired values.",
  "الف) الگوهای مورد علاقه و ارزش‌ها": "a) Favorite role models & values",
  "قهرمانان رسانه‌ای مورد علاقه": "Favorite media heroes",
  "کودک به کدام شخصیت‌های کارتونی یا فیلمی (ایرانی/خارجی) علاقه نشان می‌دهد؟ (اختیاری)": "Which cartoon or film characters (Iranian/foreign) does the child like? (optional)",
  "صفات تحسین‌شده": "Admired traits",
  "کدام ویژگیِ این شخصیت‌ها برای کودک جذاب‌تر است؟ (حداکثر ۲ مورد)": "Which trait of these characters appeals most to the child? (up to 2)",
  "شجاعت و قدرت جسمانی (مثل یک ابرقهرمان)": "Bravery and physical strength (like a superhero)",
  "مهربانی و کمک به دیگران (مثل یک دوست دلسوز)": "Kindness and helping others (like a caring friend)",
  "هوش و توانایی حل معما (مثل یک محقق)": "Cleverness and puzzle-solving (like a detective)",
  "پشتکار و توانایی غلبه بر شکست": "Perseverance and overcoming failure",
  "توانایی‌های جادویی یا ویژه (خارج از دنیای واقعی)": "Magical or special powers (beyond the real world)",
  "ارزش‌های مورد نظر": "Desired values",
  "مهم‌ترین ارزش‌هایی که مایلید در داستان منتقل شوند؟ (حداکثر ۳ مورد)": "The most important values you'd like the story to convey? (up to 3)",
  "امید و خوش‌بینی در برابر مشکلات": "Hope and optimism in the face of problems",
  "کار گروهی و همکاری با دیگران": "Teamwork and cooperation with others",
  "خودکنترلی و توانایی صبر کردن": "Self-control and patience",
  "مهربانی و همدلی": "Kindness and empathy",
  "احترام به قوانین و مسئولیت‌پذیری": "Respect for rules and responsibility",
  "ب) سناریوی مطلوب": "b) Desired scenario",
  "در داستان، مانع یا چالشی که کودک با آن روبه‌روست چگونه باید حل شود؟": "In the story, how should the obstacle or challenge the child faces be resolved?",
  "با قدرت و شجاعتِ قهرمان، سریع و کوبنده شکست بخورد": "Defeated quickly and decisively by the hero's strength and courage",
  "ماهیتِ غیرواقعی، خنده‌دار یا قابل‌مدیریتِ آن برملا شود (مثلاً هیولا فقط یک گربهٔ پشمالو باشد)": "Its unreal, funny, or manageable nature revealed (e.g. the monster is just a fluffy cat)",
  "قهرمان از طریق یک مهارتِ جدید (مثلاً نفسِ عمیق یا فکر کردن) بر آن غلبه کند": "The hero overcomes it through a new skill (e.g. deep breathing or thinking)",
  "قهرمان داستان برای غلبه بر مسئله، کدام ابزار/مهارت را به کار گیرد؟": "Which tool/skill should the hero use to overcome the problem?",
  "قدرت/سلاح‌های جادویی و ماورایی": "Magical, supernatural powers/weapons",
  "گفتگوی درونیِ مثبت (تکرار جملات مثبت به خودش)": "Positive self-talk (repeating encouraging phrases to themselves)",
  "تکنیک‌های آرام‌سازی (تنفس عمیق) و پیش‌رفتنِ گام‌به‌گام (مواجههٔ تدریجی)": "Relaxation techniques (deep breathing) and step-by-step progress (gradual exposure)",
  "کمک‌گرفتن از بزرگ‌سالان یا متخصصان در حوزهٔ مسئله": "Getting help from adults or specialists in the problem area",
  "ترس از تاریکی / تنها خوابیدن": "Fear of the dark / sleeping alone",
  "ترس از حیوانات یا صداهای بلند": "Fear of animals or loud noises",
  "ترس از غریبه‌ها یا موقعیت‌های جدید": "Fear of strangers or new situations",
  "اضطراب جدایی": "Separation anxiety",
  "ترس از آسیب جسمانی": "Fear of physical harm",
  // ── Questionnaire-first funnel + first-run screen ──
  "امشب برای که قصه بگوییم؟": "Who shall we tell a story to tonight?",
  "نام فرزندتان را بگویید تا دنیای قصه‌هایش را بسازیم — قصه‌هایی که خودش قهرمانشان است.": "Tell us your child's name and we'll build their world of stories — stories where they are the hero.",
  "شناخت {name} را شروع کنیم": "Let's get to know {name}",
  "آمادهٔ شروع": "Ready to start",
  "برای دریافت داستان‌های مخصوص {name}، ابتدا پرسشنامه را تکمیل کنید": "To receive {name}'s own stories, first complete the questionnaire",
  "پرسشنامهٔ {name} آماده است — با تهیهٔ اشتراک، قصه‌ها شروع می‌شوند": "{name}'s questionnaire is ready — pick a plan and the stories begin",
  "پرسشنامه از قبل تکمیل شده — ساخت اولین داستان همین حالا آغاز می‌شود 🌙": "Your questionnaire is already in — the first story is being made right now 🌙",
  "{name} را شناختیم!": "We know {name} now!",
  "حالا می‌دانیم قصه‌های {name} باید چه شکلی باشند. برای شروع، یکی از پلن‌ها را انتخاب کنید.": "Now we know what {name}'s stories should be. Pick a plan to begin.",
  "انتخاب پلن و شروع قصه‌ها ✨": "Choose a plan and start the stories ✨",
  "بعداً انتخاب می‌کنم": "I'll choose later",

  // ── Season check-in + corrected funnel copy ──
  "پرسشنامه تکمیل شد ✓ قصه‌ها با فعال‌شدن اشتراک شروع می‌شوند": "Questionnaire complete ✓ stories begin once the plan is active",
  "با اشتراک فعال، هفته‌ای دو قصه دریافت می‌کنید": "With an active plan you get two stories a week",
  "تمرکز این ماه:": "This month's focus:",
  "افزودن ضحا قصه به صفحهٔ اصلی": "Add Zoha Ghese to your home screen",
  "یک پرسش کوتاه دربارهٔ {name}": "A quick question about {name}",
  "چند ثانیه وقت می‌برد و قصه‌های ماه بعد را دقیق‌تر می‌کند.": "It takes seconds, and it makes next month's stories sharper.",
  "قصه‌های این ماه روی «{focus}» کار کردند.": "This month's stories worked on “{focus}”.",
  "چقدر تغییر دیده‌اید؟": "How much change have you seen?",
  "ماه بعد روی چه چیزی تمرکز کنیم؟": "What should next month focus on?",
  "همین حالا": "Current",
  "کار شده": "Done",
  "ثبت پاسخ": "Send answer",
  "در حال ثبت...": "Sending…",
  "خطا در ثبت پاسخ": "Could not send your answer",
  "بعداً — قصه‌ها به‌هرحال ادامه دارند": "Later — the stories continue either way",
  "ثبت شد، ممنون!": "Got it — thank you!",
  "قصه‌های ماه بعدِ {name} حول «{focus}» ساخته می‌شوند.": "Next month's stories for {name} will be built around “{focus}”.",
  "قصه‌های ماه بعد بر اساس پاسخ شما تنظیم شد.": "Next month's stories have been set from your answer.",
  "یک پیشنهاد دوستانه": "A friendly suggestion",
  "یک دورهٔ کامل قصه روی این موضوع کار کرد و تغییر محسوسی ندیدید. این نه به‌معنای مشکل جدی است و نه تشخیص — فقط نشانهٔ آن است که شاید گفت‌وگو با یک مشاور کودک کمکِ سریع‌تری باشد. ما از ماه بعد روی موضوع دیگری تمرکز می‌کنیم.": "A full course of stories worked on this and you saw no real change. That is neither a serious problem nor a diagnosis — it just suggests a conversation with a children's counsellor might help faster. From next month we will focus on something else.",
  "باشه": "OK",
  "هیچ تغییری ندیدم": "No change at all",
  "خیلی کم": "Very little",
  "کمی بهتر شده": "A little better",
  "پیشرفت خوبی داشته": "Good progress",
  "خیلی بهتر شده": "Much better",
  // DigiPay installments (2026-10-05)
  "پرداخت قسطی با دیجی‌پی": "Pay in installments with DigiPay",
  "پرداخت قسطی با": "Pay in installments with",
  "امکان پرداخت قسطی با دیجی‌پی": "Pay in installments with DigiPay",
  "همهٔ طرح‌ها را می‌توانید قسطی بخرید — دکمهٔ آبی پایین صفحه.": "Every plan can be bought in installments — the blue button at the bottom.",
  "یا پرداخت قسطی با دیجی‌پی": "or pay in installments with DigiPay",
  "مبلغ پرداخت قسطی": "Installment total",
  "تخفیف خرید چندماهه فقط برای پرداخت یک‌جاست.": "The multi-month discount applies to paying in full only.",
  "دیجی‌پی برای بررسی اعتبار قسطی، شمارهٔ موبایلِ صاحب حساب را لازم دارد.": "DigiPay needs the account holder's mobile number to check installment credit.",
  "ادامه در دیجی‌پی": "Continue to DigiPay",
  "صفحهٔ پرداخت دیجی‌پی در مرورگر باز شد. روش قسطی را همان‌جا انتخاب کنید؛ پس از پرداخت به همین‌جا بازگردید تا اشتراک خودکار فعال شود.": "DigiPay's payment page opened in your browser. Choose installments there, then come back here — your plan activates automatically.",
  // Exact age + games (2026-10-05)
  "قصه‌ها دقیقاً برای همین سن نوشته می‌شوند.": "Stories are written for exactly this age.",
  "قصه‌ها برای همین سن نوشته می‌شوند. تا پایان اشتراک، سن فقط در همان بازهٔ سنی قابل تغییر است.": "Stories are written for this age. Until the plan ends, the age can only change within the same age range.",
  "بازهٔ سنی قفل است": "Age range locked",
  "بازی‌های {name}": "{name}'s games",
  "بازی‌های آرام، مخصوصِ ویژگی‌های همین کودک": "Calm games picked for this child",
  "بعد از پرسشنامه، بازی‌های مخصوصِ او اینجا می‌آید": "After the questionnaire, their own games appear here",
  "بازی": "Play",
  // Child gender (2026-10-17)
  "جنسیت کودک": "Child's gender",
  "دختر": "Girl",
  "پسر": "Boy",
  "جنسیت قفل است": "Gender locked",
  "جنسیت کودک را انتخاب کنید": "Choose the child's gender",
  "قهرمانِ قصه‌ها هم‌جنسِ کودک نوشته می‌شود.": "The stories' hero is written as a girl or a boy, like your child.",
  "تا پایان اشتراک، جنسیت قابل تغییر نیست.": "Gender can't be changed until the plan ends.",
  "نام و آواتار قابل تغییر است · سن و جنسیت تا پایان اشتراک قفل است": "Name and avatar can change · age and gender are locked until the subscription ends",
  "نام، سن، جنسیت و آواتار قابل تغییر است": "Name, age, gender and avatar can change",
  // ── 2026-10-27: no first-run screen, the three steps, renewal any time, join auto-check ──
  "نام فرزند": "Child's name",
  "هنوز اضافه نشده": "Not added yet",
  "سه قدم تا اولین قصهٔ شخصی": "Three steps to the first personal story",
  "دو قدم تا اولین قصه": "Two steps to the first story",
  "افزودن": "Add",
  "ویرایش": "Edit",
  "شروع": "Start",
  "دیدن طرح‌ها": "See plans",
  "انتخاب طرح": "Choose a plan",
  "پر کردن پرسشنامه": "Fill in the questionnaire",
  "{name} اضافه شد": "{name} added",
  "نام، سن و جنسیت — کمتر از یک دقیقه": "Name, age and gender — under a minute",
  "بعد از قدم ۱": "After step 1",
  "تکمیل شد — بازی‌های مخصوص {name} باز شد": "Done — {name}'s own games are open",
  "حدود ۱۰ تا ۱۵ دقیقه، رایگان": "About 10–15 minutes, free",
  "اشتراک فعال است": "Your plan is active",
  "اشتراک فعال است — روزهایش از تکمیل پرسشنامه شمرده می‌شود": "Your plan is active — its days count from the questionnaire",
  "هر وقت خواستید — حتی پیش از دو قدم دیگر": "Any time — even before the other two steps",
  "بازی‌های آرام": "Calm games",
  "۱۱ بازی آرام — بعد از قدم ۱ و ۲، مخصوصِ کودک شما چیده می‌شوند": "11 calm games — after steps 1 and 2 they're picked for your child",
  "نگاه کن": "Take a look",
  "قصه‌های شخصی": "Personal stories",
  "قصه‌های شخصی با همان سه قدم بالا شروع می‌شوند": "Personal stories start with the three steps above",
  "قصه‌ها بعد از تکمیل پرسشنامه شروع می‌شوند": "Stories start once the questionnaire is done",
  "تمدید یا خرید طرح بعدی": "Renew or buy the next plan",
  "قصه‌های تعاملی": "Interactive tales",
  "{n} کتاب": "{n} books",
  "کتابخانه": "Library",
  "تمدید اشتراک": "Renew subscription",
  "اشتراک فعلی تا {date} فعال است. طرحی که حالا بخرید، درست بعد از پایان آن شروع می‌شود — بدون فاصله و بدون از دست رفتن حتی یک روز.":
    "Your current plan runs until {date}. A plan bought now starts right when it ends — no gap, not a single day lost.",
  "اشتراک فعلی فعال است. طرحی که حالا بخرید، درست بعد از پایان آن شروع می‌شود.": "Your current plan is active. A plan bought now starts right when it ends.",
  "۲ داستان صوتی در هفته، مخصوص فرزند شما": "2 audio stories a week, made for your child",
  "می‌توانید همین حالا طرح را بخرید و بعد فرزندتان را اضافه کنید و پرسشنامه را پر کنید. قصه‌ها پس از پرسشنامه شروع می‌شوند و روزهای اشتراک هم از همان روز شمرده می‌شود.":
    "You can buy a plan now and add your child and fill in the questionnaire afterwards. Stories start after the questionnaire, and the plan's days count from that day.",
  "اشتراک {plan} فعال شد.": "Your {plan} plan is active.",
  "حالا فرزندتان را اضافه کنید و پرسشنامه را پر کنید؛ قصه‌ها از همان لحظه شروع می‌شوند و روزهای اشتراک هم از همان روز شمرده می‌شود 🌙":
    "Now add your child and fill in the questionnaire — stories start from that moment, and the plan's days count from that day 🌙",
  "اشتراک شما آماده است — فقط بگویید برای چه کسی است": "Your plan is ready — just tell us who it's for",
  "بعد از عضویت به همین‌جا برگردید؛ خودکار وارد می‌شوید.": "After joining, come back here — you'll be let in automatically.",
  "پس از عضویت، خودکار وارد می‌شوید…": "You'll be let in automatically once you've joined…",
  "ارسال به گفتگوی من": "Send to my chat",
  "در حال ارسال…": "Sending…",
  "در گفتگوی شما با ربات است": "It's in your chat with the bot",
  "ارسال ناموفق بود. دوباره امتحان کنید.": "Sending failed. Please try again.",
  "قصه به‌صورت فایل صوتی در گفتگوی {app} با ربات ضحا قصه می‌آید؛ همان‌جا پخش و ذخیره می‌شود.":
    "The story arrives as an audio file in your {app} chat with the Zoha Ghese bot — play and save it right there.",
  // ── The Bazaar Android app (2026-10-29) ──
  "ورود با بازار": "Sign in with Bazaar",
  "ورود با حساب بازار": "Sign in with your Bazaar account",
  "۱. ورود با حساب بازار": "1. Sign in with your Bazaar account",
  "قصه‌ها و اشتراک فرزندتان به حساب بازار شما وصل می‌شود تا روی هر گوشی‌ای در دسترس باشد. شماره یا رمز لازم نیست.":
    "Your child's stories and plan are tied to your Bazaar account, so they're there on any phone. No number or password needed.",
  "ورود انجام نشد. دوباره امتحان کنید.": "Sign-in didn't complete. Please try again.",
  "برای ورود، اپ «بازار» باید روی گوشی نصب و به‌روز باشد.": "To sign in, the Bazaar app must be installed and up to date.",
  "در حال ورود...": "Signing in...",
  "برای خرید طرح، ابتدا با حساب بازار وارد شوید. اشتراک به همین حساب وصل می‌شود.":
    "To buy a plan, first sign in with your Bazaar account. The plan is tied to it.",
  "صفحهٔ پرداخت بازار باز شد. پس از پرداخت، اشتراک به‌صورت خودکار فعال می‌شود.":
    "Bazaar's payment page is open. Once you pay, the plan turns on by itself.",
  "پرداخت {n} تومان با بازار": "Pay {n} Toman with Bazaar",
  "پرداخت با بازار": "Pay with Bazaar",
  "پرداخت امن از طریق بازار": "Secure payment through Bazaar",
  "ورود با بازار، سپس نام، سن و جنسیت": "Sign in with Bazaar, then name, age and gender",
  // 2026-11-03 — plan upgrade + the 5-day money-back guarantee
  "{n} روز": "{n} days",
  "ضمانت": "guarantee",
  "ضمانت بازگشت وجه": "Money-back guarantee",
  "ارتقای طرح": "Upgrade plan",
  "مابه‌التفاوت": "Difference",
  "{n} داستان صوتی بیشتر": "{n} more audio stories",
  "طرح فعلی {plan} است. با ارتقا، همین اشتراک بلندتر می‌شود: قصه‌ها و روزهای طرح جدید (با قصه‌های هدیه‌اش) به آن اضافه می‌شود و فقط مابه‌التفاوت قیمت دو طرح را می‌پردازید.": "Your current plan is {plan}. Upgrading lengthens this same subscription: the new plan's stories and days (with its gift stories) are added to it, and you pay only the price difference between the two plans.",
  "طرح‌های دو و سه ماهه با پرداخت یک‌جا (غیرقسطی) {n} روز ضمانت بازگشت وجه دارند. جزئیات در «قوانین و مقررات».": "2- and 3-month plans paid in full (not in installments) carry a {n}-day money-back guarantee. Details in «Terms & Conditions».",
  "پرداخت {n} تومان": "Pay {n} Toman",
  "ارتقا به طرح بلندتر — فقط با پرداخت مابه‌التفاوت": "Upgrade to a longer plan — pay only the difference",
  "{d} روز و {h} ساعت": "{d} days {h} hours",
  "{d} روز": "{d} days",
  "{h} ساعت": "{h} hours",
  "درخواست شما ثبت شده و در حال بررسی است.": "Your request has been received and is being reviewed.",
  "درخواست شما پذیرفته شد؛ مبلغ به‌زودی واریز می‌شود.": "Your request was accepted; the refund will be sent soon.",
  "مبلغ بازگردانده شد.": "The refund has been sent.",
  "درخواست پذیرفته نشد و اشتراک دوباره فعال است.": "The request was not accepted and the subscription is active again.",
  "طرح‌های دو و سه ماهه با پرداخت یک‌جا، تا {n} روز پس از پرداخت؛ یک بار برای هر حساب.": "2- and 3-month plans paid in full, up to {n} days after payment; once per account.",
  "اشتراکی که شامل ضمانت باشد ندارید. این ضمانت برای طرح‌های دو و سه ماهه‌ای است که یک‌جا (نه قسطی) پرداخت شده باشند.": "You have no subscription covered by the guarantee. It applies to 2- and 3-month plans paid in full (not in installments).",
  "طرح {plan}": "{plan} plan",
  "ضمانت این حساب قبلاً استفاده شده است": "This account has already used its guarantee",
  "{left} از مهلت ضمانت باقی مانده": "{left} left on the guarantee",
  "درخواست بازگشت وجه ثبت شده است": "A refund request has been filed",
  "وجه این اشتراک بازگردانده شده است": "This subscription has been refunded",
  "خرید قسطی شامل ضمانت نیست": "Installment purchases aren't covered",
  "مهلت ضمانت این اشتراک تمام شده است": "The guarantee period for this subscription has ended",
  "درخواست بازگشت وجه": "Request a refund",
  "با ثبت درخواست، اشتراک همان لحظه متوقف می‌شود. مبلغ پس از کسر {fee} تومان کارمزد (در خرید از بازار: کارمزد و مالیات بازار) بازگردانده می‌شود.": "Submitting stops the subscription immediately. The amount is refunded minus a {fee} Toman fee (for Bazaar purchases: Bazaar's commission and taxes).",
  "برای بهتر شدن ضحا قصه، لطفاً به این چند پرسش کوتاه پاسخ دهید. پاسخ به همهٔ آن‌ها برای ثبت درخواست لازم است.": "To help us improve Zoha Ghese, please answer these few short questions. All of them are required to submit the request.",
  "حساب واریز": "Refund account",
  "شمارهٔ کارت یا شبا (IR…)": "Card or Sheba number (IR…)",
  "نام و نام خانوادگی صاحب حساب": "Account holder's full name",
  "مبلغ به‌صورت {n} ستاره به حساب تلگرام شما بازمی‌گردد.": "{n} Stars will be returned to your Telegram account.",
  "مبلغ قابل بازگشت: {n} تومان ({paid} تومان پرداختی منهای {fee} تومان کارمزد).": "Refund: {n} Toman ({paid} Toman paid minus a {fee} Toman fee).",
  "مبلغ پرداختی پس از کسر کارمزد و مالیات کافه‌بازار بازگردانده می‌شود.": "The amount paid is refunded minus Cafe Bazaar's commission and taxes.",
  "می‌دانم که با ثبت درخواست، اشتراک همین حالا متوقف می‌شود و این ضمانت فقط یک بار برای حساب من قابل استفاده است.": "I understand that submitting stops the subscription right now, and that this guarantee can be used only once on my account.",
  "ثبت درخواست ناموفق بود. دوباره تلاش کنید.": "Submitting the request failed. Please try again.",
  "ثبت درخواست بازگشت وجه": "Submit refund request",
  "درخواست ثبت شده": "Request filed",
  "استفاده شده": "Used",
  "{left} باقی مانده": "{left} left",
  "فعال نیست": "Not active",
  "اشتراک": "Subscription",
  "بدون تبلیغات": "No ads",
  "{n} روز ضمانت بازگشت وجه": "{n}-day money-back guarantee",
};

// The questionnaire's own strings (v3) — an entry above wins on a shared key.
for (const [k, v] of Object.entries(Q_EN)) if (!(k in APP_EN)) APP_EN[k] = v;
